/**
 * =========================================================================================
 * ATS
 * =========================================================================================
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {UAlertProvider} from 'ubs-framework/v2/UAlert';
import App from './App';
import Logout from "./app-ats/Logout";

import './index.scss';
import "react-datepicker/dist/react-datepicker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'ubs-framework/v2/plugin/UTimerWidget/index.scss'
import storeMaster from './store';
import * as serviceWorker from './serviceWorker';
import * as Sentry from "@sentry/react";

const environment = window.location.href.includes('.superworks.net') ? 'staging' : window.location.href.includes('.superworks.app') ? 'beta' : window.location.href.includes('.superworks.com') ? 'production' : 'local';

Sentry.init({
  dsn: "https://8dd3bb752b0422944fd102b3baeffa48@o4510471619149824.ingest.us.sentry.io/4510622375477248",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
  environment: environment
});
document.addEventListener('keypress', logKey);

const {store, persistor} = storeMaster();

let logger = function () {
    /* +-------------------------------------------------------------------+
     desc: Enable or disable logger and disable warn function.
     +-------------------------------------------------------------------+ */
    let oldConsoleLog = null;
    let pub = {};

    pub.enableLogger = function enableLogger() {
        if (oldConsoleLog == null) return;
        window['console']['log'] = oldConsoleLog;
        console.log('=== LOG ENABLED ===');
    };
    pub.disableLogger = function disableLogger() {
        oldConsoleLog = console.log;
        window['console']['log'] = () => {
        };
    };
    pub.disableWarn = function disableWarn() {
        window['console']['warn'] = () => {
        };
    };
    return pub;
}();

function logKey(e) {
    /* +-------------------------------------------------------------------+
     desc: define log enable disable key.
     +-------------------------------------------------------------------+ */
    if (e.ctrlKey && e.shiftKey) {
        switch (e.code) {
            case 'KeyS':
                logger.disableLogger();
                break;
            case 'KeyE':
                logger.enableLogger();
                break;
            default:
                break;
        }
    }
}

if (window.location.hostname === 'recruit.superworks.com') {
    logger.disableLogger();
    logger.disableWarn();
} else {
    logger.disableWarn();
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <UAlertProvider>
                    <Router>
                        <Switch>
                            <Route exact path="/logout" component={Logout}/>
                        </Switch>
                        <App/>
                    </Router>
                </UAlertProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
